import MappingOriginForm from "~/models/mapping/mappingOriginForm";
import MappingOriginSalesforce from "~/models/mapping/mappingOriginSalesforce";
import MappingOriginObjectModel from "~/models/mapping/mappingOriginObjectModel";
import {TMappingOriginType, TModelMappingOriginType} from "~/interfaces/mappingInterfaces";
import {ModelType} from "~/enums/modelType";
import assertNever from "../../../global/assetNever";

export type MappingOriginTypes =
  MappingOriginForm |
  MappingOriginObjectModel |
  MappingOriginSalesforce
export type MappingOriginKlassTypes =
  typeof MappingOriginForm |
  typeof MappingOriginObjectModel |
  typeof MappingOriginSalesforce

export const MappingOriginSFKlasses = [MappingOriginSalesforce];

export default class MappingOriginFactory {
  static getClass(type: TMappingOriginType): MappingOriginKlassTypes {
    switch (type) {
      case ModelType.Form:
        return MappingOriginForm
      case ModelType.ObjectModel:
        return MappingOriginObjectModel
      case ModelType.SObject:
        return MappingOriginSalesforce
      default:
        assertNever(type)
    }
  }

  static getClassForModelMapping(type: TModelMappingOriginType): MappingOriginKlassTypes {
    switch (type) {
      case ModelType.Form:
      case ModelType.FormElement:
      case ModelType.LookUpField:
      case ModelType.PaymentStep:
      case ModelType.PaymentStepLineItem:
        return MappingOriginForm
      case ModelType.ObjectModel:
      case ModelType.RelationIdentifier:
        // TODO: Alex: Should a RelationIdentifier specific class go here?
        return MappingOriginObjectModel
      case ModelType.SObject:
      case ModelType.SObjectChildRelationship:
      case ModelType.SObjectReferenceField:
        return MappingOriginSalesforce
      default:
        assertNever(type)
    }
  }
}